const className = 'Brand'

export default class Brand {
  constructor (Parse) {
    this.Parse = Parse
  }

  /**
   * Get a brand query
   * http://parseplatform.org/Parse-SDK-JS/api/classes/Parse.Query.html
   * @param {string} name - Brand name
   */
  get (name) {
    var Class = this.Parse.Object.extend(className)
    var query = new this.Parse.Query(Class)
    query.equalTo('data.name', name)
    query.include('data')
    return query
  }

  /**
   * Get a brand query to find all brands
   */
  getAll () {
    var Class = this.Parse.Object.extend(className)
    var query = new this.Parse.Query(Class)
    query.include('data')
    return query
  }

  /**
   * Create a Brand
   * http://parseplatform.org/Parse-SDK-JS/api/classes/Parse.Object.html#methods_save
   * @param {string} name - Brand name
   * @param {string} logo - Brand logo
   */
  set (name, logo, options = {}) {
    var Class = this.Parse.Object.extend(className)
    var object = new Class()
    var data = {name: name, logo: logo}
    object.set('data', data, {error: this.onError})
    return object.save(null, options)
  }

  onError (object, error) {
    console.log('Error', error)
  }
}



//////////////////
// WEBPACK FOOTER
// ./parse-model/Brand.mjs
// module id = 5U/q
// module chunks = 0